import { useInfiniteQuery } from '@northladder/services';

import { INBOUND_API } from '../../../inboundAPIClient';
import { ISourceDetailsParams } from '../../../types';

/**
 * This is to track the Inbound details from the backend.
 */
const INBOUND_SOURCE_DETAILS_KEY = 'inbound-source-details-query';

/**
 * This hook fetches the inbound details from mock APi.
 */
export const useInboundSourceDetailsQuery = (params: ISourceDetailsParams) => {
  const { page, limit, sourceId } = params;
  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    isPending,
    refetch,
  } = useInfiniteQuery({
    queryKey: [INBOUND_SOURCE_DETAILS_KEY, page, limit, sourceId],
    networkMode: 'always',
    initialPageParam: 1,
    retry: false,
    queryFn: () => INBOUND_API.fetchSourceDetails(params),
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = allPages.length + 1;
      const currentCount = allPages.length * limit;

      return currentCount < lastPage.total ? nextPage : undefined;
    },
  });

  return {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    isPending,
    refetch,
  };
};
